var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-3cy68l",
    "aria-label": "gift",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 11H19.5C20.3284 11 21 10.3284 21 9.5V8.5C21 7.67157 20.3284 7 19.5 7H4.5C3.67157 7 3 7.67157 3 8.5V9.5C3 10.3284 3.67157 11 4.5 11H10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3V3C11.1046 3 12 3.89543 12 5V7H10C8.89543 7 8 6.10457 8 5V5C8 3.89543 8.89543 3 10 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3V3C15.1046 3 16 3.89543 16 5V5C16 6.10457 15.1046 7 14 7H12V5C12 3.89543 12.8954 3 14 3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 4,
    height: 14,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.99c222211034da7bbe56f8c4e01f2849.svg";
export { ForwardRef as ReactComponent };